import React from 'react';

import MUIButton from '@mui/material/Button';

export default function Button(props) {
    return (
        <MUIButton {...props} />
    );
};